import { Component, EventEmitter, Input, Output } from '@angular/core';
export type AssessmentSubmitConfirmTheme =  'sa' | 'sb' | 'frf';
export type AssessmentDialogMode = 'confirm' | 'success';

@Component({
  selector: 'app-assessment-submit-confirm',
  templateUrl: './assessment-submit-confirm.component.html',
  styleUrls: ['./assessment-submit-confirm.component.scss']
})
export class AssessmentSubmitConfirmComponent {
@Input() open = false;
  @Input() mode: AssessmentDialogMode = 'confirm';
  @Input() theme: AssessmentSubmitConfirmTheme = 'frf';
  @Input() successTitle = 'Congratulation';
  @Input() successMessage = '';
    @Input() confirmTitle = 'Submit assessment?';
  @Input() confirmMessage =
    'Are you sure you want to submit the assessment.';
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();

  onBackdropClick(): void {
    if (this.mode === 'success') {
      this.dismissed.emit();
      return;
    }
    this.cancelled.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  onConfirm(): void {
    this.confirmed.emit();
  }

  onDismiss(): void {
    this.dismissed.emit();
  }
}
